import { asLabel } from '@shure/shared/angular/utils/i18n';

export function mapMuteStatusToTranslocoKey(muteStatus?: boolean): string {
	switch (muteStatus) {
		case true:
			return asLabel('shAgGrid.common.labels.muted');
		case false:
			return asLabel('shAgGrid.common.labels.un-muted');
		case undefined:
			return asLabel('shAgGrid.common.labels.mute-unsupported');
	}
}
